/**
 * Scheme check for a value that reaches a URL-bearing DOM property.
 *
 * The analytics integrations take their URLs from server configuration rather than from a
 * literal, so the scheme is verified at the point of use instead of trusted upstream. A
 * third-party script is executed with this origin's privileges; loading one over plain http
 * hands that to anyone on the network path, so only a local dev host is allowed to.
 */
export function isTrustedScriptUrl(value: string): boolean {
  let url: URL;

  try {
    url = new URL(value);
  } catch {
    // Relative, malformed, or a scheme the URL parser rejects - none of which belong here.
    return false;
  }

  if (url.protocol === 'https:') {
    return true;
  }

  return url.protocol === 'http:' && (url.hostname === 'localhost' || url.hostname === '127.0.0.1');
}
